import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { ModalDialogProps } from "./modal-dialog.types";
import { cn } from "@/lib/utils";

export const ModalDialog = ({
  title,
  children,
  description,
  closeLabel,
  submitLabel,
  maxMidth,
  showFooter,
  titleStyle,
  descriptionStyle,
  headerStyle,
  image,
  imageStyle,
  open,
  handleClose,
  handleConfirm,
  enableButton,
  type,
  className = "",
}: ModalDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogContent
        className={cn(className, maxMidth ? maxMidth : "sm:max-w-md")}
      >
        <DialogHeader className={`${headerStyle}`}>
          {image && (
            <img
              className={`${imageStyle ? imageStyle : "w-16 h-16"}`}
              src={image}
            />
          )}

          <DialogTitle className={titleStyle}>{title}</DialogTitle>
          {description && (
            <DialogDescription className={descriptionStyle}>
              {description}
            </DialogDescription>
          )}
        </DialogHeader>
        <div className="flex items-center space-x-2">
          <div className="grid flex-1 gap-2">{children}</div>
        </div>
        {showFooter && (
          <DialogFooter className="sm:justify-start">
            {type !== "submit" && (
              <div className=" sm:ml-3 sm:w-auto">
                <Button
                  type={type}
                  onClick={() => handleConfirm()}
                  disabled={!enableButton}
                >
                  {submitLabel ? submitLabel : "Confirmar"}
                </Button>
              </div>
            )}
            <DialogClose asChild>
              <Button type="button" variant="secondary">
                {closeLabel ? closeLabel : "Cancelar"}
              </Button>
            </DialogClose>
          </DialogFooter>
        )}
      </DialogContent>
    </Dialog>
  );
};
